module.exports = __webpack_public_path__ + "static/media/slide-2.e11345f6.jpg";